<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/pencil.svg?raw'
export default {
  name: 'IconPencil',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
